import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavigation } from './NavigationContext';

const CustomLink = ({ to, children, ...props }) => {
  const { handleNavigation } = useNavigation();

  const handleClick = (event) => {
    event.preventDefault();
    handleNavigation(to); // Call the centralized navigation handler
  };

  return (
    <a href={to} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default CustomLink;
